module.exports = __webpack_public_path__ + "static/media/add-value-pig.40f2b4a8.png";